import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../../../AbstractElements";
import { AdvanceInitTitle, DataTitle } from "../../../../../Constants/Constants";
import RowCreateCallback from "./RowCreateCallback";
import StockResult from "./StockResult";
import { Fragment } from "react/jsx-runtime";

const AdvanceInitContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={AdvanceInitTitle} parent={DataTitle} />
      <Container fluid>
        <Row>
          <StockResult />
          <RowCreateCallback />
        </Row>
      </Container>
    </Fragment>
  );
};
export default AdvanceInitContainer;
